// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.summaryTag[data-v-ba5f0e6a] {\n  width: 80px;\n  text-align: left;\n}\n[data-v-ba5f0e6a] .cell {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
